// extracted by mini-css-extract-plugin
export default {"USSalesTax":"Lq35moN ZHWKoMf leavesden3"};